import React from 'react';
import cn from 'classnames';

import Line from './components/Line';
import Circle from './components/Circle';
import { ListItem } from '../../../components/List';

import styles from './style.scss';

interface IProps {
  isGrid: boolean;
}

const FakeProjectItem = ({ isGrid }: IProps) => (
  <ListItem className={cn({ [styles['is-grid']]: isGrid })}>
    <div className={styles.inner}>
      <div className={cn(styles.part, styles['is-first'])}>
        <Line
          className={cn(styles.line, styles.animated)}
          width={isGrid ? 0.45 : 0.35}
        />
        <Line
          className={cn(styles.line, styles.animated)}
          width={isGrid ? 0.35 : 0.25}
        />
      </div>
      {!isGrid && (
        <div className={cn(styles.line, styles['is-middle'])}>
          <Line className={cn(styles.line, styles.animated)} width={0.2} />
        </div>
      )}
      <div className={cn(styles.part, styles['is-last'])}>
        <Circle className={cn(styles.circle, styles.animated)} />
        <Line
          className={cn(styles.line, styles.animated)}
          width={isGrid ? 0.4 : 0.3}
        />
      </div>
    </div>
  </ListItem>
);

export default FakeProjectItem;
